/**
 * 카카오 로그인 콜백 페이지
 *
 * 카카오 로그인 인증 후 리다이렉트되는 페이지입니다.
 * 공통 OAuthCallback 컴포넌트를 사용하여 인증 코드를 처리합니다.
 */

import React from "react";
import OAuthCallback from "./OAuthCallback";

const KakaoCallback: React.FC = () => {
    return <OAuthCallback provider="KAKAO" />;
};

export default KakaoCallback;
